import { createSlice } from '@reduxjs/toolkit';

import { PromocodeState } from 'types/promocode';
import { INITIAL_LIST_PARAMS } from 'config';

const initialState: PromocodeState = {
  isLoading: false,
  promocodeList: {},
  promocodeListParams: INITIAL_LIST_PARAMS,
  filtersListParams: INITIAL_LIST_PARAMS,
};

const slice = createSlice({
  name: 'promocode',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    resetError(state) {
      state.error = undefined;
    },

    getPromocodeList(state, action) {
      state.isLoading = false;
      state.promocodeList = action.payload;
    },

    getPromocode(state, action) {
      state.isLoading = false;
      state.promocode = action.payload;
    },

    setPromocodeListParams(state, action) {
      state.promocodeListParams = action.payload;
    },

    setFiltersListParams(state, action) {
      state.filtersListParams = action.payload;
    },

    clearPromocode(state) {
      state.promocode = undefined;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  hasError,
  resetError,
  getPromocodeList,
  setPromocodeListParams,
  getPromocode,
  clearPromocode,
  setFiltersListParams,
} = slice.actions;
